<script>
    export let message;
</script>

{#if message}
<div class="container {message.status == 200 ? "green" : "red"}">
    <h2>{message.message.title}</h2>
    <p>{message.message.description}</p>
</div>
{/if}